const ROUTE_PATH = {
    HOME: '/',
    POLICIES_PERSONAL_INFO: '/policy/personalInfo',
    POLICIES_INTEGRATION_SERVICE: '/policy/integrationService',
    POLICIES_HELLO_OPERATION: '/policy/helloOperation',
    POLICIES_ACCOUNT_TERM: '/policy/accountTerm',
}

export default ROUTE_PATH;
